export default __webpack_public_path__ + "static/media/medication.d6f39a62.png";